import { useEffect, useState } from 'react';

// Matches Tailwind's `md` breakpoint (768px): below it the layouts go single-column.
const MOBILE_QUERY = '(max-width: 767px)';

const matches = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(MOBILE_QUERY).matches;

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(matches);
  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    )
      return;
    const query = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(query.matches);
    onChange();
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);
  return isMobile;
};
